{
  "title": "Passwort zurücksetzen",
  "subtitle": "E-Mail eingeben für Link zum Zurücksetzen",
  "emailLabel": "E-Mail",
  "sendButton": "Link senden",
  "sendingButton": "Senden...",
  "backToLogin": "Zurück zum Login",
  "successTitle": "Überprüfe deine E-Mails",
  "successMessage": "Link zum Zurücksetzen gesendet an",
  "expiryNote": "Der Link läuft in 1 Stunde ab",
  "errors": {
    "emailRequired": "Bitte gib deine E-Mail-Adresse ein",
    "invalidEmail": "Bitte gib eine gültige E-Mail-Adresse ein",
    "sendFailed": "E-Mail konnte nicht gesendet werden. Bitte erneut versuchen."
  }
}
